import React, { useEffect, useState } from "react";
import { Trophy, Gift } from "lucide-react";

// Public, unauthenticated fetch — bypasses the auth interceptor.
function fetchLeaderboard() {
  return fetch("/api/public/referral-leaderboard?limit=5", { credentials: "omit" })
    .then((r) => (r.ok ? r.json() : []))
    .catch(() => []);
}

export default function ReferralLeaderboard() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    fetchLeaderboard().then(setRows);
  }, []);

  if (!rows || rows.length === 0) return null;

  return (
    <section
      className="py-20 px-6 border-t border-[#E6E3DB] bg-[#FBF6EC]"
      data-testid="referral-leaderboard"
    >
      <div className="max-w-3xl mx-auto">
        <div className="flex items-start gap-4">
          <div className="shrink-0 h-10 w-10 rounded-sm bg-[#C05C3D] flex items-center justify-center">
            <Trophy className="h-5 w-5 text-white" />
          </div>
          <div className="flex-1">
            <p className="eyebrow text-[#C05C3D]">Referral leaderboard</p>
            <h2 className="font-serif text-3xl md:text-4xl mt-1 leading-tight">
              The members building the Finhabits community.
            </h2>
            <p className="text-[#4d4f4c] mt-2 text-sm md:text-base max-w-xl">
              Every friend referred earns the inviter 30 free days. Here are the
              top members keeping each other on the loop.
            </p>
          </div>
        </div>

        <ol className="mt-8 divide-y divide-[#E6E3DB] bg-white border border-[#E6E3DB]">
          {rows.map((row, i) => (
            <li
              key={`${row.display_name}-${i}`}
              className="flex items-center gap-4 px-5 py-4"
              data-testid={`leaderboard-row-${i}`}
            >
              <span
                className={`shrink-0 h-9 w-9 rounded-full flex items-center justify-center font-serif text-lg ${
                  i === 0
                    ? "bg-[#C05C3D] text-white"
                    : i === 1
                    ? "bg-[#2F6F8F] text-white"
                    : i === 2
                    ? "bg-[#607762] text-white"
                    : "bg-[#EAE7DF] text-[#2C302E]"
                }`}
              >
                {i + 1}
              </span>
              <span
                className="flex-1 font-serif text-xl truncate"
                data-testid={`leaderboard-name-${i}`}
              >
                {row.display_name}
              </span>
              <span className="text-sm text-[#4d4f4c] hidden sm:inline">
                {row.referrals_count} referral{row.referrals_count === 1 ? "" : "s"}
              </span>
              <span
                className="inline-flex items-center gap-1.5 text-sm font-medium text-[#C05C3D]"
                data-testid={`leaderboard-days-${i}`}
                title={`${row.referrals_count} friend${row.referrals_count === 1 ? "" : "s"} referred`}
              >
                <Gift className="h-3.5 w-3.5" />
                {row.free_days_earned} free days earned
              </span>
            </li>
          ))}
        </ol>

        <p className="text-xs text-[#787671] mt-4">
          Names shown with last initial only. You can opt out of public mentions
          in Settings.
        </p>
      </div>
    </section>
  );
}
